import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AIS140TicketDetailsComponent } from './ais140-ticket-details.component';

const routes: Routes = [
  {
    path: 'ais140-ticket-details',
    data: { name: 'My Ticket Details page', isTab: true },
    component: AIS140TicketDetailsComponent,
  },
  {
    path: 'ais140-ticket-details/:id',
    component: AIS140TicketDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AIS140TicketDetailsRoutingModule {}
